<script setup>
import FormTextarea from '../../../../components/Forms/FormTextarea.vue';

defineProps({
    question: {
        type: Object,
        required: true,
    },
});

const value = defineModel({ type: [Array, null], default: null });
</script>

<template>
    <div class="flex flex-col gap-2">
        <div class="" v-for="(answer, i) in value" :key="i">
            <div>
                <span>#{{ i + 1 }}</span>
            </div>
            <FormTextarea
                v-model="answer.text"
                :required="question.is_required && i < question.options.min"
                :placeholder="question.is_required ? '' : $t('messages.survey_question_not_required_placeholder')"
                class="w-full"
                :name="`question_${question.id}_${i}`"
            />
        </div>
    </div>
</template>
